// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inscriptions_stepper{
    margin: 0;
    padding: 12px var(--space-x3);
    background: var(--new-background-color);
}

.inscriptions_step-line__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.inscriptions_step-line__container .inscriptions_step-line {
    border-bottom: 2px solid var( --new-gray-disabled-color );
    height: 0;
    width: 100%;
    position: relative;
    top: -12px;
}

.inscriptions_step-line__container .inscriptions_step-line:first-of-type {
    margin-left: var( --space-x3 );
}

.inscriptions_step-line__container .inscriptions_step-line:last-of-type {
    margin-right: var( --space-x3 );
}

.inscriptions_step-point__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.inscriptions_step-point {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.inscriptions_step-point .inscriptions_point {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var( --new-gray-disabled-color );
    z-index: 2;
}

.inscriptions_step-line__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.inscriptions_step-line__container .inscriptions_step-line {
    border-bottom: 2px solid var( --new-gray-disabled-color );
    height: 0;
    width: 100%;
    position: relative;
    top: -12px;
}

.inscriptions_step-line__container .inscriptions_step-line:first-of-type {
    margin-left: var( --space-x3 );
}

.inscriptions_step-line__container .inscriptions_step-line:last-of-type {
    margin-right: var( --space-x3 );
}

.inscriptions_step-line.inscriptions_step-line-completed {
    border-bottom: 2px solid var( --new-green-color );
}

.baloa-username.inscriptions_step-point-label-completed {
    color: var( --new-green-color );
}

.inscriptions_point.inscriptions_step-point-completed {
    background: var( --new-green-color );
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .inscriptions_modal_component .modal2__container{
        background: var(--white-color);
    }

    .inscriptions_step-line__container .inscriptions_step-line:first-of-type{
        margin-left:0px;
    }

    .inscriptions_step-line__container .inscriptions_step-line:last-of-type{
        margin-right: 0px;
    }

    .inscriptions_stepper{ 
        background: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/stepper-inscription-modal/StepperInscriptionModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yDAAyD;IACzD,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yDAAyD;IACzD,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".inscriptions_stepper{\n    margin: 0;\n    padding: 12px var(--space-x3);\n    background: var(--new-background-color);\n}\n\n.inscriptions_step-line__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.inscriptions_step-line__container .inscriptions_step-line {\n    border-bottom: 2px solid var( --new-gray-disabled-color );\n    height: 0;\n    width: 100%;\n    position: relative;\n    top: -12px;\n}\n\n.inscriptions_step-line__container .inscriptions_step-line:first-of-type {\n    margin-left: var( --space-x3 );\n}\n\n.inscriptions_step-line__container .inscriptions_step-line:last-of-type {\n    margin-right: var( --space-x3 );\n}\n\n.inscriptions_step-point__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.inscriptions_step-point {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.inscriptions_step-point .inscriptions_point {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: var( --new-gray-disabled-color );\n    z-index: 2;\n}\n\n.inscriptions_step-line__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.inscriptions_step-line__container .inscriptions_step-line {\n    border-bottom: 2px solid var( --new-gray-disabled-color );\n    height: 0;\n    width: 100%;\n    position: relative;\n    top: -12px;\n}\n\n.inscriptions_step-line__container .inscriptions_step-line:first-of-type {\n    margin-left: var( --space-x3 );\n}\n\n.inscriptions_step-line__container .inscriptions_step-line:last-of-type {\n    margin-right: var( --space-x3 );\n}\n\n.inscriptions_step-line.inscriptions_step-line-completed {\n    border-bottom: 2px solid var( --new-green-color );\n}\n\n.baloa-username.inscriptions_step-point-label-completed {\n    color: var( --new-green-color );\n}\n\n.inscriptions_point.inscriptions_step-point-completed {\n    background: var( --new-green-color );\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .inscriptions_modal_component .modal2__container{\n        background: var(--white-color);\n    }\n\n    .inscriptions_step-line__container .inscriptions_step-line:first-of-type{\n        margin-left:0px;\n    }\n\n    .inscriptions_step-line__container .inscriptions_step-line:last-of-type{\n        margin-right: 0px;\n    }\n\n    .inscriptions_stepper{ \n        background: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
